<template>
  <div class="charge-rule">
    <!-- <div class="content-left">
      <AreaTree ref="areaTree" v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>规则名称:</label>
            <input
              clearable
              v-model="search.name"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add_btn"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list table-container">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="400px"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="规则名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="费用(月)"
            prop="amount"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="生效日期"
            prop="crtTime"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="150px">
            <template slot-scope="scope">
              <button
                type="button"
                class="edit"
                @click="addOrEdit(scope.row.id)"
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
    <!-- 添加/编辑收费规则-->
    <el-dialog
      :title="chargeRule.id ? '编辑收费规则' : '添加收费规则'"
      :visible.sync="dialogFormVisibleChargeRule"
      width="600px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      @close="closeDialog"
      class="charge-rule-dialog"
      center
    >
      <div class="dialog-header-icon">
        <i class="el-icon-setting"></i>
      </div>
      
      <el-form
        :rules="rules"
        :model="chargeRule"
        ref="formArea"
        label-position="top"
        label-width="auto"
        class="charge-rule-form"
      >
        <div class="form-grid">
          <el-form-item label="选择物业" prop="propertyId" class="form-item-full">
            <el-select
              v-model="chargeRule.propertyId"
              placeholder="请选择物业"
              filterable
              clearable
              class="full-width"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="规则名称" prop="name" class="form-item-full">
            <el-input
              v-model.trim="chargeRule.name"
              placeholder="请输入收费规则名称"
              clearable
            >
              <i slot="prefix" class="el-input__icon el-icon-edit"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="月租费用" prop="monthlyPrice" class="form-item-full">
            <el-input
              v-model.trim="chargeRule.monthlyPrice"
              placeholder="请输入月租费用"
              clearable
              type="number"
            >
              <i slot="prefix" class="el-input__icon el-icon-money"></i>
              <template slot="append">元/月</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      
      <div slot="footer" class="dialog-footer-custom">
        <el-button
          size="medium"
          @click="dialogFormVisibleChargeRule = false"
          class="cancel-button"
        >
          <i class="el-icon-close"></i>
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          @click="addEditTrue"
          class="confirm-button"
        >
          <i class="el-icon-check"></i>
          {{ chargeRule.id ? '保存修改' : '确认添加' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  getMonthlyChargeRule,
  getOneMonthlyChargeRule,
  addOrEditMonthlyChargeRule,
  getAllParkingsByEnabled,
  fetchPropertyList,
} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

export default {
  data() {
    return {
      moduleName: "parking",
      propertyList: [],
      tableListData: [],
      allParkings: [],
      dialogFormVisibleChargeRule: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        name: null,
        propertyId: null,
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      chargeRule: {
        monthlyPrice: null,
        name: null,
        id: null,
        propertyId: null,
      },
      rules: {
        name: [{ required: true, message: "请填写规则名称", trigger: "blur" }],
        monthlyPrice: [
          { required: true, message: "请填写费用", trigger: "blur" },
        ],
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
      var _this = this;
      const { propertyId, pageSize, name } = this.search;
      this.$get(getMonthlyChargeRule(), {
        enabledFlag: "y",
        parentId: propertyId ? propertyId : null,
        limit: pageSize,
        page: curPage,
        name: name ? name : null,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = rows.map((item) => {
          if (item.parentId && typeof JSON.parse(item.parentId) === "object") {
            item.propertyName = JSON.parse(item.parentId).name;
          }
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    addOrEdit(id) {
      if (!id) {
        this.dialogFormVisibleChargeRule = true;
        this.chargeRule = {
          id: null,
          name: null,
          monthlyPrice: null,
          propertyId: null,
        };
      } else {
        this.dialogFormVisibleChargeRule = true;
        this.$get(getOneMonthlyChargeRule() + "/" + id).then((res) => {
          const {
            status,
            data: { id, name, amount, parentId },
          } = res;
          if (status !== 200) return;
          this.chargeRule = {
            id,
            name,
            monthlyPrice: amount,
            propertyId: parentId,
          };
        });
      }
    },
    addEditTrue() {
      this.$refs["formArea"].validate((valid, noStri) => {
        if (valid) {
          const { propertyId, monthlyPrice, name, id } = this.chargeRule;
          if (this.chargeRule.id) {
            this.$putRequest(getOneMonthlyChargeRule() + "/" + id, {
              parentId: propertyId,
              amount: monthlyPrice,
              name,
              id,
            }).then((data) => {
              if (data.status != 200) return;
              this.$notify({
                type: "success",
                title: "成功",
                message: "收费规则修改成功!",
              });
              this.tableList(this.page.curIndex);
            });
            this.dialogFormVisibleChargeRule = false;
          } else {
            this.$postRequest(getOneMonthlyChargeRule(), {
              parentId: propertyId,
              amount: monthlyPrice,
              name,
            }).then((data) => {
              if (data.status != 200) return;
              this.$notify({
                type: "success",
                title: "成功",
                message: "收费规则设置成功!",
              });
              this.search.pageNumber = 1;
              this.tableList(this.search.pageNumber);
              this.dialogFormVisibleChargeRule = false;
            });
          }
        } else {
          return;
        }
      });
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(getOneMonthlyChargeRule() + "/" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功!",
              });
              _this.tableList(_this.page.curIndex);
            });
        }
      );
    },
    allParking() {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return;
        this.allParkings = data.data.rows;
      });
    },
    searchList: function () {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    resetForm() {
      this.$refs["formArea"].resetFields();
    },
    closeDialog() {
      this.resetForm();
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
  },

  mounted() {
    this.getAllProperty();
    this.tableList(this.search.pageNumber);
  },
  computed: {
    ...mapState(["page"]),
  },
  components: {
    Page,
    AreaTree,
  },
};
</script>
<style scoped>
/* 对话框美化样式 */
.charge-rule-dialog {
  border-radius: 12px;
}

.dialog-header-icon {
  text-align: center;
  margin-bottom: 20px;
}

.dialog-header-icon i {
  font-size: 48px;
  color: #409eff;
  opacity: 0.8;
}

.charge-rule-form {
  padding: 0 20px;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-item-full {
  width: 100%;
}

.full-width {
  width: 100%;
}

.dialog-footer-custom {
  text-align: center;
  padding: 20px 0 10px;
  border-top: 1px solid #f0f2f5;
  margin-top: 20px;
}

.cancel-button {
  margin-right: 12px;
  padding: 10px 24px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  color: #606266;
  background: #fff;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cancel-button:hover {
  border-color: #c0c4cc;
  color: #409eff;
}

.confirm-button {
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.confirm-button:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

/* 表格容器样式 */
.table-container {
  max-height: 500px;
  overflow: auto;
}

.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
  transition: background 0.3s ease;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>

<style>
/* 对话框全局样式 */
.charge-rule-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.charge-rule-dialog .el-dialog__header {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: #fff;
  padding: 20px 24px;
  text-align: center;
}

.charge-rule-dialog .el-dialog__title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.charge-rule-dialog .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.charge-rule-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 20px;
}

.charge-rule-dialog .el-dialog__body {
  padding: 30px 24px 20px;
  background: #fff;
  max-height: 60vh;
  overflow-y: auto;
}

.charge-rule-dialog .el-form-item__label {
  color: #303133;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
}

.charge-rule-dialog .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  transition: all 0.3s ease;
}

.charge-rule-dialog .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.charge-rule-dialog .el-input__prefix {
  left: 12px;
}

.charge-rule-dialog .el-input__prefix .el-input__icon {
  color: #c0c4cc;
  transition: color 0.3s ease;
}

.charge-rule-dialog .el-input.is-focus .el-input__prefix .el-input__icon {
  color: #409eff;
}

.charge-rule-dialog .el-input-group__append {
  background: #f5f7fa;
  border-left: 0;
  color: #909399;
  border-radius: 0 6px 6px 0;
  padding: 0 15px;
  font-size: 14px;
  font-weight: 500;
}

.charge-rule-dialog .el-select .el-input__inner {
  cursor: pointer;
}

.charge-rule-dialog .el-select-dropdown__item {
  padding: 0 20px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.charge-rule-dialog .el-form-item.is-error .el-input__inner {
  border-color: #f56c6c;
}

.charge-rule-dialog .el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}

.charge-rule-dialog .el-button {
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.3s ease;
}

/* 对话框滚动条样式 */
.charge-rule-dialog .el-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.charge-rule-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.charge-rule-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.3s ease;
}

.charge-rule-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>